export default __webpack_public_path__ + "static/banner-bg-d621e9d82003114fc61280ae66ae5d73.png";